import { actions } from './actions'

const initialState = {
  data: [],
}

export default function topicsProgressReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_TOPICPROGRESS_RESULT:
      return { ...state, data: action.payload }
    default:
      return state
  }
}
